import { Box } from '@chakra-ui/react';

import { OnboardingCompanyProfile } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBUpload from 'features/Onboarding/components/OBUpload';
import { getUploadKybFunction } from 'features/Storage/upload';

import MandateeHeader from '../../components/Header';
import { MandateDocumentFile } from '../../machine/model';
import locales from './locales';

interface MandateUploadProps {
  onUploadComplete: (documentFile: MandateDocumentFile) => void;
  companyProfile: Pick<
    OnboardingCompanyProfile,
    'companyProfileId' | 'legalName'
  >;
}

const DOWNLOAD_TEMPLATE_URL =
  'https://storage.googleapis.com/shine-public/product/kyb/mandate.pdf';

const MandateUpload = asBentoPage<MandateUploadProps>(
  ({ companyProfile, Layout, onPrev, onUploadComplete }) => {
    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Box paddingBottom="space-48">
          <MandateeHeader
            legalName={companyProfile.legalName}
            linkIcon="download"
            linkText={locales.template}
            linkUrl={DOWNLOAD_TEMPLATE_URL}
          />

          <OBUpload
            onSuccessfulUpload={async ({ bucketName, fileRef, url }) =>
              onUploadComplete({
                firebaseBucket: bucketName,
                firebaseRef: fileRef,
                url,
              })
            }
            uploadFile={getUploadKybFunction(companyProfile.companyProfileId)}
          >
            <OBUpload.UploadZone
              description={locales.upload.description}
              title={locales.upload.title}
            />

            <OBUpload.Checklist
              checks={[
                locales.checks.power,
                locales.checks.mandatee,
                locales.checks.contractor,
                locales.checks.company,
                locales.checks.date,
                locales.checks.signature,
              ]}
            />
          </OBUpload>
        </Box>
      </Layout>
    );
  },
);

export default MandateUpload;
